import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import configureStore from './store/configureStore';
import { loadState, saveState } from './localStorage';
import throttle from 'lodash/throttle';

import App from './App';
import 'form-components/lib/Styles/Common.scss';
import 'form-components/lib/Styles/Fonts.scss';

import registerServiceWorker from './registerServiceWorker';

const persistedState = loadState();
const store = configureStore(persistedState);

store.subscribe(
	throttle(() => {
		saveState(store.getState());
	}),
	1000,
);

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js